import useChatRoomDisplay, {
    useChatRoomDisplayState,
} from '@/hooks/useChatRoomDisplay';
import { createContext } from 'react';

export const ChatRoomDisplayContext = createContext(
    {} as useChatRoomDisplayState
);

type ChatRoomContextProps = {
    children: JSX.Element;
};

export const ChatRoomDisplayProvider = (props: ChatRoomContextProps) => {
    const { children } = props;
    const chatroom = useChatRoomDisplay();
    return (
        <ChatRoomDisplayContext.Provider value={chatroom}>
            {children}
        </ChatRoomDisplayContext.Provider>
    );
};
